frontApp.loading = {
  name: 'loading',
  description: 'Show/hide preloader',
  fullPage: {
    show(lockScroll = true, scrollElement) {
      $('body').addClass('loading js-clear-scroll-locks-prevent');
      // Lock body scroll
      if (lockScroll) {
        const scrollContainer = !scrollElement ? document.querySelector('body') : document.querySelector(scrollElement);
        if (scrollContainer) {
          document.body.style.marginRight = `${(window.innerWidth - document.documentElement.clientWidth)}px`;
          bodyScrollLock.disableBodyScroll(scrollContainer);
        }
      }
    },
    hide(lockScroll = true) {
      $('body').removeClass('loading js-clear-scroll-locks-prevent');
      // Unlock body scroll
      if (lockScroll) {
        document.body.style.marginRight = '';
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    },
  },
};
